import React from 'react'
import ReactDOM from 'react-dom';
import { createRoot } from 'react-dom/client'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import { Provider, useDispatch } from 'react-redux'
import { configureStore } from '@reduxjs/toolkit'
import App from './components/App/App'
import rootReducer from './reducers'
import './index.css'
import i18n from './i18n'
import { setParam } from './actions/params'
import { userChangedData } from './actions/data'



import './index.css'
// import 'dotenv/config'

const store = configureStore({
  reducer: rootReducer
})


let isFP = false
// the id of the div to render too
let appId = `${process.env.REACT_APP_APP_ID}` ? `${process.env.REACT_APP_APP_ID}` : 'modelcustomization'
let windowAppId = `${process.env.REACT_APP_WINDOW_APP_ID}` ? `${process.env.REACT_APP_WINDOW_APP_ID}` : 'portfolioMapper'
const initParams = {}


function getSyncScriptParams() {
  const scripts = document.getElementsByTagName('script')
  const lastScript = scripts[scripts.length - 1]
  const scriptName = lastScript
  // override from attributes if they exist
  if (scriptName.getAttribute('appId')) {
    appId = scriptName.getAttribute('appId')
  }
  if (scriptName.getAttribute('mode')) {
    isFP = scriptName.getAttribute('mode') === 'fp' ? true : false
  }

  initParams.wtRegion = `${window[windowAppId].wtRegion}` && `${window[windowAppId].wtRegion}` !== 'undefined' ? `${window[windowAppId].wtRegion}` : 'US'
  initParams.entityCCY = `${window[windowAppId].entityCCY}` && `${window[windowAppId].entityCCY}` !== 'undefined' ? `${window[windowAppId].entityCCY}` : 'USD'
  initParams.tenant = `${window[windowAppId].tenant}` && `${window[windowAppId].tenant}` !== 'undefined' ? `${window[windowAppId].tenant}` : 'wisdomtree'
  initParams.clientEmail = `${window[windowAppId].clientEmail}` && `${window[windowAppId].clientEmail}` !== 'undefined' ? `${window[windowAppId].clientEmail}` : 'unknown@unknown.com'
  initParams.dataspanApiUrl = `${process.env.REACT_APP_API_URL}`
  initParams.token = `${window[windowAppId].token}`
  initParams.version = `${process.env.REACT_APP_VERSION}` !== 'undefined' ? `${process.env.REACT_APP_VERSION}` : 'DEV'
  initParams.isFP = window.isFP ? true : isFP
  initParams.isoCode = `${window[windowAppId].isoCode}` && `${window[windowAppId].isoCode}` !== 'undefined' ? `${window[windowAppId].isoCode}` : 'en-US'

  // Change the language to that specified in the page.
  i18n.changeLanguage(initParams.isoCode)

}

// const element = document.getElementById(id)
// const root = createRoot(element)
const root = document.getElementById(appId);
getSyncScriptParams()



store.dispatch(setParam(initParams))
store.dispatch(userChangedData({ userChangedData: {} }))

// render
const rootContainer = createRoot(root);
rootContainer.render(
  <Provider store={store}>
    <BrowserRouter>
      <Routes>
        <Route
          path='*'
          element={<App params={initParams} />}
        />
      </Routes>
    </BrowserRouter>
  </Provider>,

);